module.exports = __webpack_public_path__ + "static/CannabisCloud_Overview-8933623c499dcac4a6d7527344140c05.pdf";